import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/globals.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./components/Contexts/AuthContext";
import { SocketProvider } from "./components/Contexts/SocketContext"; // Import SocketProvider
import { isSandbox } from "./sandbox/session";
import { installMockApi } from "./sandbox/mockApi";

// Sandbox: answer every /api request in the browser. Must run before the
// first render so no request can reach the real backend.
if (isSandbox()) installMockApi();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <SocketProvider>
        {" "}
        {/* Wrap the entire app with SocketProvider */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SocketProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
